import React, { ReactNode } from 'react'
import { ApiTokenPricesContext } from './context'
import { useApiTokenPrices } from './useApiTokenPrices'

interface Props {
  children: ReactNode
}

export function ApiTokenPricesProvider({ children }: Props) {
  const tokenPrices = useApiTokenPrices()

  return <ApiTokenPricesContext.Provider value={tokenPrices} children={children} />
}
